import Api from "~/service/Api";

class UserMeRepository {
  fetch(query) {
    return Api.get("/user/me", query);
  }

  update(data) {
    return Api.post("/user/me", data);
  }
}

export default UserMeRepository;
